import React, { Component } from "react";
import withFilterOptions from "../hocs/withFilterOptions";
import withItems from "../hocs/withItems";
import { Spin, Button, Icon, Checkbox, Row, Col } from "antd";
import { getModelName } from "../utils/models";
import ShowModal from "../containers/ShowModal";
import FormItem from "./FormItem";

import "./Collection/index.css";

class Collection extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const modelName = getModelName(this.props.model, this.props.attribute);
    return (
      <FormItem {...this.props}>
        {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
          <Checkbox.Group onChange={this.props.handleChange}>
            <Row>
              {this.props.items.length > 1 ? (
                this.props.items.map(i => (
                  <Col span={8} key={i.id}>
                    <Checkbox value={i.id}>{i.name}</Checkbox>
                  </Col>
                ))
              ) : (
                <Spin />
              )}
            </Row>
          </Checkbox.Group>
        )}
        {(!this.props.hasOwnProperty("showAdd") || this.props.showAdd) && (
          <ShowModal
            type="form"
            model={modelName}
            belongsTo={this.props.belongsTo}
          >
            <div className="input-add-button">
              <Button type="dashed">
                <Icon type="plus" />
              </Button>
            </div>
          </ShowModal>
        )}
      </FormItem>
    );
  }
}

export default withFilterOptions(withItems(Collection));



// WEBPACK FOOTER //
// ./src/inputs/Checkbox.js